// extracted by mini-css-extract-plugin
export default {"container":"InsulinFormNameSelect_container__ST0lF"};